import qs from 'qs';

const Dobd = {
    namespaced: true,
    state: {
        dobdData: [],
    },

    getters: {
        dobdData (state) {
            return state.dobdData;
        },
    },

    mutations: {

        /**
         * Установить значение DOBD рейтинга
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['dobdData'] = items;
        },

    //     /**
    //      * Обновить значение элемента DOBD рейтинга
    //      * @param state
    //      * @param item
    //      * @param index
    //      */
    //     setItem (state, { item, index }) {
    //         state['dobdData'][index] = item;
    //     },

    //     /**
    //      * Добавить значение элемента DOBD рейтинга
    //      * @param state
    //      * @param item
    //      */
    //     addItem (state, { item }) {
    //         state['dobdData'].push(item);
    //     },

    //     /**
    //      * Удалить элемент из DOBD рейтинга
    //      * @param state
    //      * @param item
    //      */
    //     remove (state, { item }) {
    //         state['dobdData'] = state['dobdData'].filter(iItem => iItem !== item);
    //     },
    },

    actions: {

        /**
         * Получение данных по DOBD рейтингам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getDobdData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service' : rootGetters.service.dobd,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по DOBD рейтингам получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN dobd.js | getDobdData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по DOBD рейтингам!'),
                        reject(err);
                });
            })
        },

        // /**
        //  * Сохранение данных по DOBD рейтингам
        //  * @param commit
        //  * @param data
        //  * @returns {Promise<any>}
        //  */
        // saveDobdData ({ commit, dispatch, getters, rootGetters }, data) {
        //     return new Promise((resolve, reject) => {
        //         dispatch('loading/isLoading', true, {root:true});
        //         const str = JSON.stringify(data.data);
        //         axios({
        //             url: rootGetters.rootUrl + 'list/save',
        //             method: 'POST',
        //             headers: {
        //                 'content-type': 'application/x-www-form-urlencoded'
        //             },
        //             data: qs.stringify({
        //                 'data': str,
        //                 'token': this.getters['auth/getToken'], 
        //                 'service' : rootGetters.service.dobd,
        //             }),
        //         }).then(response => {
        //             console.log(response.data);
        //             // Если редактирование
        //             if (data.index !== -1) {
        //                 commit('setItem', {
        //                     item: data.data,
        //                     index: data.index
        //                 });
        //                 dispatch('loading/isLoading', false, {root:true});
        //                 window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по DOBD рейтингам успешно отредактированы!');

        //             // Если сохранение нового
        //             } else {
        //               data.data.dobdId = response.data[0].dobdId;
        //                 commit('addItem', {
        //                     item: data.data
        //                 });
        //                 dispatch('loading/isLoading', false, {root:true});
        //                 window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый конкурент успешно создан!');
        //             }
        //             resolve();
        //         }).catch(err => {
        //                 dispatch('loading/isLoading', false, {root:true});
        //                 window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
        //                 console.log('ERROR IN dobd.js | saveDobdData : ' + err);
        //                 reject(err);
        //         });
        //     })
        // },

        // /**
        //  * Удаление DOBD рейтинга
        //  * @param commit
        //  * @param data
        //  * @returns {Promise<any>}
        //  */
        // removeDobdData ({ commit, dispatch, getters, rootGetters }, data) {
        //     return new Promise((resolve, reject) => {
        //         dispatch('loading/isLoading', true, {root:true});
        //         const str = JSON.stringify(data.item);
        //         axios({
        //             url: rootGetters.rootUrl + 'list/delete',
        //             method: 'POST',
        //             headers: {
        //                 'content-type': 'application/x-www-form-urlencoded'
        //             },
        //             data: qs.stringify({
        //                 'data': str,
        //                 'token': this.getters['auth/getToken'], 
        //                 'service' : rootGetters.service.dobd,
        //             }),
        //         }).then(response => (
        //             commit('remove', {
        //                 item: data.item
        //             }),
        //             dispatch('loading/isLoading', false, {root:true}),
        //             window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'DOBD рейтинг успешно удален!'),
        //             resolve()
        //         )).catch(err => {
        //             dispatch('loading/isLoading', false, {root:true});
        //             window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении DOBD рейтинга!'),
        //             console.log('ERROR IN dobd.js | removeDobdData : ' + err);
        //             reject(err);
        //         });
        //     })
        // },
    },
};

export default Dobd;





// WEBPACK FOOTER //
// ./src/store/modules/dobd.js